import {
    Box,
    IconButton,
    InputAdornment,
    Typography,
    Button,
    CardActions,
    CardContent,
    Container,
    Drawer,
    FormControl,
    FormHelperText,
    Grid,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    TextField
} from '@mui/material';  
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from "dayjs"
import 'dayjs/locale/ko'
import Magnify from 'mdi-material-ui/Magnify'
import moment from 'moment'
import { useEffect, useState, useRef } from 'react'
import { Controller, useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { apiService } from '../../api/axiosClient'
import NewWindow from '../../utils/newwindow'

const DialogPoint = (props) => {
    const { show, setShow, setReload } = props
    const {
        control,
        handleSubmit,
        formState: { errors },
        reset,
        setValue,
        getValues
    } = useForm()
    const [searchShow, setSearchShow] = useState(false);
    const postBtnRef = useRef(null);
    const defaultValues = {
        username: '',
        po_point: 10,
        po_expire_date: new Date(moment().add(1, 'years')),
        po_source: "구매",
    }

    useEffect(() => {
        reset(defaultValues);
    }, [show])

    const onSubmit = async (data, e) => {
        e.preventDefault();

        const params = {
            "username": data.username,
            "po_orderid": "0",
            "po_point": data.po_point,
            "po_use_point": 0,
            "po_expired": 0,
            "po_expire_date": dayjs(data.po_expire_date).format("YYYY-MM-DD"),
            "po_kind": "acc",
            "po_source": data.po_source
        };

        try {
            await apiService.post('/points', params);
            toast.success('등록 되었습니다.');
            setReload(reload => reload + 1);
        } catch (error) {
            toast.error('등록이 실패했습니다.');
            console.error(error);
        } finally {
            setShow(false);
        }
    }

    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setShow(open);
    };

    const SearchWindow = () => {
        return (
          searchShow ? (
                <NewWindow 
                    url={`/find/user?field=username&q=`} 
                    title={"사용자 검색"} 
                    features = {{ left: '100px', top: '100px', width: '800px', height: '900px'}}
                    onUnload={handleClose} /> ) 
                : ""
        )
    }

    window.userReceiver = (users) => {
        setValue('username', users.username)
    }

    const handleClick = () => {
        postBtnRef.current.disabled = true;
        setSearchShow(true);
    };

    const handleClose = () => {
        postBtnRef.current.disabled = false;
        setSearchShow(false);
    }

    return (
        <>
            <Drawer anchor='right' open={show} onClose={toggleDrawer(false)}>
                <Container sx={{width: '800px', pt: 8, px: '2rem !important'}}>
                    <form onSubmit={handleSubmit(onSubmit)} id="pointform">
                        <CardContent sx={{ pt: 8 }}>
                            <Box sx={{ mb: 9, textAlign: 'center' }}>
                                <Typography variant='h5' sx={{ mb: 3, lineHeight: '2rem' }}>
                                    포인트 등록
                                </Typography>
                            </Box>

                            <Grid container spacing={6}>
                                <Grid item xs={12} md={6}>
                                    <FormControl fullWidth>
                                        <Controller
                                            name='username'
                                            control={control}
                                            rules={{ required: true }}
                                            defaultValue=""
                                            render={({ field: { value, onChange } }) => (
                                                <Paper component="div" sx={{ display: 'flex', alignItems: 'center' }} >
                                                    <TextField
                                                        value={value}
                                                        fullWidth
                                                        disabled
                                                        label='사용자 ID'
                                                        id='username'
                                                        onChange={onChange}
                                                        placeholder='사용자 ID를 검색하세요'
                                                        error={Boolean(errors.username)}
                                                        aria-describedby='validation-async-username'
                                                        InputProps={{
                                                            endAdornment: (
                                                            <InputAdornment position="end">
                                                                <IconButton edge="end" ref={postBtnRef} onClick={handleClick} sx={{padding: 2, marginRight: 1}}>
                                                                    <Magnify />
                                                                </IconButton>
                                                            </InputAdornment>
                                                            ),
                                                        }}
                                                    />
                                                </Paper>
                                            )}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormControl fullWidth>
                                        <Controller
                                            name='po_point'
                                            control={control}
                                            rules={{ required: true }}
                                            defaultValue=""
                                            render={({ field: { value, onChange } }) => (
                                                <TextField
                                                    value={value}
                                                    fullWidth
                                                    label='포인트'
                                                    id='po_point'
                                                    onChange={onChange}
                                                    placeholder='포인트를 입력해주세요'
                                                    error={Boolean(errors.po_point)}
                                                    aria-describedby='validation-async-po_point'
                                                />
                                            )}
                                        />
                                        {errors.po_point && (
                                            <FormHelperText sx={{ color: 'error.main' }} id='validation-async-po_point'>
                                                필수
                                            </FormHelperText>
                                        )}
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <FormControl fullWidth>
                                        <Controller
                                            name='po_expire_date'
                                            control={control}
                                            rules={{ required: true }}
                                            defaultValue=""
                                            render={({ field: { value, onChange } }) => (
                                                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
                                                    <DatePicker
                                                        label='유효기간'
                                                        value={value}
                                                        onChange={onChange}
                                                        inputFormat={dayjs(value).format("YYYY-MM-DD")}
                                                        renderInput={(params) => <TextField {...params} />}
                                                    />
                                                </LocalizationProvider>
                                            )}
                                        />
                                        {errors.po_expire_date && (
                                            <FormHelperText sx={{ color: 'error.main' }} id='validation-async-po_expire_date'>
                                                필수
                                            </FormHelperText>
                                        )}
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <FormControl fullWidth>
                                        <InputLabel id='po_source'>포인트유형</InputLabel>
                                        <Controller
                                            name='po_source'
                                            control={control}
                                            rules={{ required: true }}
                                            defaultValue=""
                                            render={({ field: { value, onChange } }) => (
                                                <Select
                                                    label='포인트유형'
                                                    value={value}
                                                    onChange={onChange}
                                                    labelId='po_source'
                                                    error={Boolean(errors.po_source)}
                                                >
                                                    <MenuItem value="구매">구매</MenuItem>
                                                    <MenuItem value="보상">보상</MenuItem>
                                                    <MenuItem value="첫구매">첫구매</MenuItem>
                                                    <MenuItem value="리뷰">리뷰</MenuItem>
                                                </Select>
                                            )}
                                        />
                                        {errors.po_source && (
                                            <FormHelperText sx={{ color: 'error.main' }} id='validation-async-po_source'>
                                                필수
                                            </FormHelperText>
                                        )}
                                    </FormControl>
                                </Grid>

                            </Grid>
                        </CardContent>
                    </form>

                    <CardActions className='card-action'>
                        <Button type="submit" form="pointform" variant='contained'> 등록 </Button>
                        <Button variant='outlined' color='secondary' onClick={() => setShow(false)}> 취소 </Button>
                    </CardActions>
                </Container>
            </Drawer>
            <SearchWindow/>
        </>
        
    )
}

export default DialogPoint